import React, { Component } from "react";
import _ from "lodash";
import { gql, graphql, compose } from "react-apollo";
import { Link } from "react-router-dom";
import withLoading from "../../modules/loader/withLoading";

class ListPostContainer extends Component {
  state = {};

  _handleDelete = async id => {

    if(!window.confirm("confirm delete ?")){
      return
    }
    try {
      await this.props.deletePostMutation({
        variables: {
          id
        }
      });

      window.location.reload();
    } catch (error) {
      alert(error.message);
    }
  };

  render() {
    return (
      <div>
        <ul className="collection">
          {_.map(this.props.data.allPosts, post => (
            <ListItemPost
              key={post.id}
              post={post}
              onDelete={this._handleDelete}
            />
          ))}
        </ul>
      </div>
    );
  }
}

const ListItemPost = ({ post, onDelete }) => (
  <li className="collection-item avatar">
    <Link to={`/posts/${post.id}`}>
      {/* <img src="images/yuna.jpg" alt="" className="circle" /> */}
      <span className="title">FROM: {post.author.name}</span>
      <p>TO: {post.sendURL}</p>
    </Link>

    <div className="secondary-content right-align">
      <Link to={`/edit/${post.id}`} className="orange-text">
        edit
      </Link>
      <br />
      
      <a href="#" onClick={() => onDelete(post.id)} className="red-text">
        delete
      </a>
    </div>
  </li>
);

const DELET_POST = gql`
  mutation DeletePostMutation($id: ID!) {
    deletePost(id: $id) {
      id
    }
  }
`;

const ALL_POST_QUERY = gql`
  query AllPostQuery($authorId: ID, $fbId: String) {
    allPosts(filter: { author: { id: $authorId, facebookUserId: $fbId } }) {
      id
      imageId
      author {
        name
        facebookUserId
      }
      sendURL
    }
  }
`;

export default compose(
  graphql(ALL_POST_QUERY, {
    options: ownProps => {
      return {
        variables: {
          authorId: _.get(ownProps, "queryUser.User.id"),
          fbId: _.get(ownProps, "queryUser.User.facebookUserId")
        }
      };
    }
  }),
  graphql(DELET_POST, {
    name: "deletePostMutation"
  }),
  withLoading
)(ListPostContainer);



// WEBPACK FOOTER //
// ./src/templates/list-post/ListPostContainer.js